//@ts-nocheck
import { Component } from "react";
import { Tag, Tooltip, Card, Typography } from "antd";
import GridActionComponent from "../common/gridAction";
import { showAssignBusinessUnit, userCanEdit } from "../../../libs/validations";
import { Avatar, AvatarSize } from "@xemplo/avatar";
const { Title } = Typography;

type State = any;
class UserDisplayCard extends Component<{}, State> {
  constructor(props: {}) {
    super(props);
    this.state = {};
  }
  getEditComponent = ({ user }) => {
    const { member, userType, editComponent } = this.props;
    if (userType === "psp") {
      return userCanEdit({ user, member }) ? editComponent : "";
    }
    return editComponent;
  };
  render() {
    const {
      content,
      handleAction,
      reminderComponent,
      userType,
      enableDisableComponentNameGrid,
      enableDisableMFAComponentNameGrid,
      mandatoryDeviceEnrolmentGrid,
      optionalDeviceEnrolmentGrid,
      disableDeviceEnrolmentGrid,
      member,
      dashboardView,
      pspId,
      assignBusinessUnitGrid,
    } = this.props;
    return (
      content && (
        <Card
          className="card card-prop hand shadow-default display-card-user h-full pb-0"
          bordered="false"
          onClick={(e) => handleAction({ data: content, action: "view" })}
        >
          <div className="flex text-overflow justify-center items-center flex-col">
            <div className="mb-2.5">
              <Avatar user={content} size={AvatarSize.xl} />
              <div className="display-card-user-status text-center mt-2">
                <Tag
                  className={`modifiedTag ${
                    content.activated ? "bg-success" : "bg-danger"
                  }`}
                >
                  {content.activated ? "Active" : "Inactive"}
                </Tag>
              </div>
            </div>
            <div className="text-overflow w-245 text-center leading-5">
              <Title ellipsis className="card-title" level={3}>
                {content.firstName} {content.lastName}
              </Title>

              <div className="my-4 relative flex justify-center">
                {content.mobilePhone && (
                  <Tooltip title={content.mobilePhone}>
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      xmlns="https://www.w3.org/2000/svg"
                      className="mr-1"
                    >
                      <circle cx="12" cy="12" r="12" fill="#EEEEEE" />
                      <path
                        d="M17.4521 14.7057C16.9544 14.1944 15.5399 13.2365 14.6127 13.2365C14.398 13.2365 14.2105 13.2843 14.0571 13.3831C13.6038 13.6729 13.2424 13.8978 13.0686 13.8978C12.9732 13.8978 12.8709 13.8126 12.6459 13.6183L12.6084 13.5842C11.9846 13.0423 11.8517 12.9025 11.6097 12.6503L11.5483 12.5855C11.504 12.5412 11.4665 12.5003 11.429 12.4628C11.2177 12.2446 11.0643 12.0878 10.5223 11.4743L10.4985 11.447C10.2394 11.1539 10.069 10.963 10.0588 10.8232C10.0485 10.6869 10.1678 10.4653 10.4712 10.0529C10.8393 9.55521 10.853 8.94166 10.5155 8.22925C10.2462 7.66683 9.80652 7.12826 9.41794 6.65446L9.38385 6.61356C9.04981 6.20452 8.66122 6 8.22832 6C7.7477 6 7.34889 6.25906 7.13756 6.3954C7.12051 6.40563 7.10347 6.41926 7.08643 6.42949C6.61263 6.72945 6.26835 7.1419 6.13883 7.56116C5.94453 8.19176 5.815 9.00983 6.74556 10.7107C7.55 12.1833 8.27945 13.1718 9.43839 14.3614C10.5292 15.4794 11.0132 15.8407 12.0971 16.6247C13.3038 17.4973 14.4627 17.9984 15.274 17.9984C16.0273 17.9984 16.6204 17.9984 17.4657 16.9792C18.352 15.9089 17.9839 15.2545 17.4521 14.7057Z"
                        fill="#555555"
                      />
                    </svg>
                  </Tooltip>
                )}
                {content.emailAddress && (
                  <Tooltip title={content.emailAddress}>
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      xmlns="https://www.w3.org/2000/svg"
                      className="mr-1"
                    >
                      <circle cx="12" cy="12" r="12" fill="#EEEEEE" />
                      <path
                        d="M16.8 7H7.2C6.54 7 6.006 7.5625 6.006 8.25L6 15.75C6 16.4375 6.54 17 7.2 17H16.8C17.46 17 18 16.4375 18 15.75V8.25C18 7.5625 17.46 7 16.8 7ZM16.56 9.65625L12.318 12.4188C12.126 12.5438 11.874 12.5438 11.682 12.4188L7.44 9.65625C7.29 9.55625 7.2 9.3875 7.2 9.20625C7.2 8.7875 7.638 8.5375 7.98 8.75625L12 11.375L16.02 8.75625C16.362 8.5375 16.8 8.7875 16.8 9.20625C16.8 9.3875 16.71 9.55625 16.56 9.65625Z"
                        fill="#555555"
                      />
                    </svg>
                  </Tooltip>
                )}
                {content.dateOfBirth && (
                  <Tooltip title="Date of Birth">
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      xmlns="https://www.w3.org/2000/svg"
                      className="mr-1"
                    >
                      <circle cx="12" cy="12" r="12" fill="#EEEEEE" />
                      <path
                        d="M11.871 6C11.871 6 11.8498 6.58771 11.7391 6.87572C11.5794 7.29139 11.0346 7.58882 11.0855 8.02389C11.1314 8.41603 11.9455 8.85097 11.9455 8.85097C11.9455 8.85097 12.6318 8.37586 12.7711 8.03849C12.8808 7.77283 12.8328 7.46624 12.7367 7.19682C12.5773 6.74989 11.871 6 11.871 6ZM11.9341 9.07476C11.7023 9.07476 11.5213 9.25895 11.5213 9.48829V9.92129L12.4673 9.40072C12.4265 9.21455 12.2553 9.07476 12.0545 9.07476H11.9341ZM12.473 9.56128L11.9455 9.84345L11.5213 10.1013V10.6948L12.473 10.1645V9.56128ZM12.473 10.33L11.5213 10.8408V11.3224H7.26135C7.24154 11.3224 7.22325 11.3212 7.20401 11.3224C6.91554 11.3419 6.69374 11.5034 6.69374 11.7019V13.7356V14.5091C6.78371 14.5668 6.88141 14.6195 6.98614 14.6648C7.35057 14.8225 7.79912 14.8987 8.23602 14.8789C8.62673 14.8611 9.00976 14.7667 9.31963 14.6113C9.62953 14.4558 9.86539 14.2392 9.99044 13.9983L10.1108 13.7696L10.2312 13.9983C10.3762 14.2653 10.6612 14.4974 11.0282 14.6502C11.3952 14.803 11.8439 14.8755 12.2781 14.8497C12.6596 14.827 13.0332 14.7321 13.333 14.5772C13.6328 14.4223 13.8613 14.2102 13.9809 13.9739L14.0898 13.755L14.2217 13.9642C14.3748 14.209 14.642 14.4282 14.9728 14.5821C15.3036 14.736 15.7017 14.8245 16.108 14.8399C16.5251 14.8557 16.9488 14.7897 17.312 14.6551V13.7356V11.7019C17.312 11.4901 17.0549 11.3224 16.7386 11.3224H12.473V10.9916L11.8538 11.3224H11.5786L12.473 10.8213V10.33ZM11.7162 11.9549L12.1519 12.2955L12.7253 12.1836L12.4787 12.6409L12.7826 13.069L12.1921 13.0107L11.8022 13.3901L11.6875 12.8939L11.1429 12.6944L11.6589 12.4512L11.7162 11.9549ZM15.5174 12.8209L15.9532 13.1615L16.5265 13.0544L16.28 13.5069L16.5838 13.9399L15.9933 13.8815L15.6034 14.2561L15.4888 13.7647L14.9441 13.5653L15.4658 13.322L15.5174 12.8209ZM7.92642 12.8744L8.36216 13.2198L8.94123 13.108L8.68896 13.5653L8.99283 13.9934L8.40803 13.935L8.01242 14.3145L7.89775 13.8183L7.35881 13.6188L7.87482 13.3755L7.92642 12.8744ZM14.1128 14.1977C13.9669 14.3944 13.7571 14.5675 13.4935 14.7037C13.1541 14.8791 12.7387 14.9846 12.3067 15.0102C11.8146 15.0395 11.3066 14.9645 10.8906 14.7913C10.5589 14.6532 10.2963 14.454 10.1166 14.2269C9.96492 14.4259 9.74554 14.6066 9.47444 14.7426C9.12392 14.9185 8.69507 15.0193 8.25322 15.0394C7.75858 15.0619 7.25536 14.9796 6.84281 14.801C6.79126 14.7787 6.74217 14.7579 6.69374 14.7329V15.9832V16.3676H7.26135H16.7386H17.312V15.9832V14.8448C16.9359 14.9659 16.5107 15.0213 16.0908 15.0054C15.6355 14.9881 15.1944 14.8859 14.8237 14.7134C14.532 14.5778 14.2867 14.401 14.1128 14.1977ZM8.96416 15.2048C9.25741 15.2048 9.49737 15.4084 9.49737 15.6573C9.49737 15.9061 9.25741 16.1049 8.96416 16.1049C8.67092 16.1049 8.43669 15.9061 8.43669 15.6573C8.43669 15.4084 8.67092 15.2048 8.96416 15.2048ZM11.957 15.2243C12.2502 15.2243 12.4902 15.4279 12.4902 15.6767C12.4902 15.9256 12.2502 16.1243 11.957 16.1243C11.6638 16.1243 11.4295 15.9256 11.4295 15.6767C11.4295 15.4279 11.6638 15.2243 11.957 15.2243ZM14.9556 15.2973C15.2488 15.2973 15.483 15.496 15.483 15.7449C15.483 15.9937 15.2488 16.1973 14.9556 16.1973C14.6623 16.1973 14.4224 15.9937 14.4224 15.7449C14.4224 15.496 14.6623 15.2973 14.9556 15.2973ZM18 16.5135L6 16.5183L6.00572 16.8686C6.00884 17.1656 6.28686 17.3308 6.5676 17.3308L17.4094 17.3356C17.7448 17.3357 18.0025 17.1569 18 16.888V16.5134L18 16.5135Z"
                        fill="#555555"
                      />
                    </svg>
                  </Tooltip>
                )}
              </div>
            </div>
          </div>
          {!dashboardView && (
            <GridActionComponent
              classname="card-item mt-4 mr-4"
              buttonClassName="animated fadeIn position-absolute-top position-absolute-top-right"
              claims={this.props.claims}
              handleAction={(options: any) =>
                handleAction({ ...options, data: content, record: content })
              }
              editComponentNameGrid={this.getEditComponent({
                user: content,
              })}
              hasNoComponents={false}
              viewComponentName={""}
              sendReminderComponentNameGrid={
                !content.activated && reminderComponent
              }
              enableDisableComponentNameGrid={enableDisableComponentNameGrid}
              enableDisableMFAComponentNameGrid={
                enableDisableMFAComponentNameGrid
              }
              mandatoryDeviceEnrolmentGrid={mandatoryDeviceEnrolmentGrid}
              optionalDeviceEnrolmentGrid={optionalDeviceEnrolmentGrid}
              disableDeviceEnrolmentGrid={disableDeviceEnrolmentGrid}
              enabled={content && content.enabled}
              mfaEnabled={content && content.mfaEnable}
              deviceEnrolmentValue={content && content.deviceEnrolmentEnable}
              showAssignBusinessUnits={showAssignBusinessUnit({
                user: content,
                member,
                userType,
                pspId,
              })}
              assignBusinessUnitGrid={
                userType === "psp" ? assignBusinessUnitGrid : ""
              }
              member={member}
              userType={userType}
              record={content}
            />
          )}
        </Card>
      )
    );
  }
}

export default UserDisplayCard;
